import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import GermanyPayrollModal from '../ActionModals/GermanyPayrollModal'
import { hideReduxModal, showReduxModal } from '../../../Reducers/UI/actions'
import { updatePayrollData } from '../../../Containers/City/Page/Ambasador/gql'
import { COUNTRY_CODE } from '../../../constants'

const useGermanyPayrollData = (ambassador, user, setGermanyPayroll) => {
  const showPayrollData = ambassador.city.country.code == COUNTRY_CODE.GERMANY

  if (!showPayrollData) {
    return [null, showPayrollData]
  }

  const dispatch = useDispatch()
  let payrollDataInitial = {
    name: 'Payroll data',
    isCustomData: true,
  }

  const [payrollData, setPayrollData] = useState(null)

  useEffect(() => {
    if (ambassador.germanyPayrollData) {
      payrollDataInitial = {
        ...payrollDataInitial,
        ...ambassador.germanyPayrollData,
        updatedAt: new Date(Number(ambassador.germanyPayrollData.updatedAt)),
        comment: ambassador.germanyPayrollData.comment || '',
        uploader: ambassador.email,
        url: 'modal',
        actorId: +user.id,
      }
      setPayrollData(payrollDataInitial)
    } else {
      setPayrollData({
        name: 'Payroll data',
        isCustomData: true,
      })
    }
  }, [ambassador])

  const openPayrollDataModal = () => {
    return dispatch(
      showReduxModal({
        children: (
          <GermanyPayrollModal
            germanyPayrollData={ambassador.germanyPayrollData}
            onClose={() => {
              dispatch(hideReduxModal())
            }}
          />
        ),
        onConfirm: () => dispatch(hideReduxModal()),
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'contract',
      }),
    )
  }

  const handlePayrollDataChange = async ({ document, input, isEdit }) => {
    try {
      await updatePayrollData(input)
      setPayrollData({ ...document, ...input, isEdit })
    } catch (error) {
      console.error({ error })
    }
  }

  const onPayrollDataStatusChange = async ({
    document,
    status,
    rejectReason,
  }) => {
    const input = { userId: ambassador.id, status, rejectReason }
    await handlePayrollDataChange({ document, input })
    setGermanyPayroll({ ...document, status })
  }

  const onPayrollDataEdit = data => {
    setPayrollData(prevInfo => ({ ...prevInfo, data, isEdit: true }))
  }

  const onPayrollDataSave = document => {
    handlePayrollDataChange({
      document,
      input: {
        userId: ambassador.id,
        comment: payrollData.comment,
        actorId: +user.id,
      },
      isEdit: false,
    })
  }

  return [
    {
      openPayrollDataModal,
      payrollData,
      handlePayrollDataChange,
      onPayrollDataEdit,
      onPayrollDataSave,
      onPayrollDataStatusChange,
      setPayrollData,
    },
    showPayrollData,
  ]
}

export default useGermanyPayrollData
